<template>
  <fragment v-if="!isLink">
    <button
      type="button"
      @click="onBtnClick"
      :class="extraClasses"
      :id="extraId"
      :disabled="disabled"
      ref="btn"
    >
      <slot></slot>
    </button>
  </fragment>
  <fragment v-else>
    <a
      href="javascript:undefined"
      @click.prevent="onBtnClick"
      :class="extraClasses"
      :id="extraId"
      :disabled="disabled"
      ref="btn"
    >
      <slot></slot>
    </a>
  </fragment>
</template>
<script>
export default {
  name: 'TrackerButton',
  props: {
    extraClasses: String,
    callBack: {
      type: Function,
      default: () => {},
    },
    disabled: Boolean,
    extraId: {
      type: String,
      default: () => '',
    },
    params: Array,
    isPreventDefault: {
      type: Boolean,
      default: () => false,
    },
    isStopPropagation: {
      type: Boolean,
      default: () => false,
    },
    isClickOnce: {
      type: Boolean,
      default: () => false,
    },
    isLink: {
      type: Boolean,
      default: () => false,
    },
    trackerInfo: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      isClicked: false,
    };
  },

  methods: {
    onBtnClick(e) {
      if (!this.isClicked) {
        if (this.isPreventDefault) {
          e.preventDefault();
        }
        if (this.isStopPropagation) {
          e.stopPropagation();
        }
        this.callBack.apply(this, this.params);
        // console.log(1);
        if (window._hmt && this.trackerInfo) {
          const { action, opt_label, opt_value } = this.trackerInfo;
          window._hmt.push([
            '_trackEvent',
            'button',
            action,
            opt_label,
            opt_value,
          ]);
        }
      }
    },
  },
};
</script>
